module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8718/img/pumpkin.svg"